import { useContext, useMemo, useEffect } from 'react';

import { isStableUIEnabledForTests } from '@confluence/e2e-url-override/entry-points/isStableUIEnabledForTests.ts';

import { Context } from './ChoreographerAssetsContext.tsx';
import { choreographerContextStub } from './ChoreographerContextStub.tsx';

declare global {
	interface Window {
		__PO_ASSET_DISPLAYED__?: boolean;
	}
}

interface ChoreographerPluginWithState {
	state?: {
		isDisplayingMessage?: boolean;
	};
}

export const useChoreographerAssets = () => {
	const ctx = useContext(Context);

	if (!ctx) {
		throw new Error(
			'ChoreographerAssetsContext not found, did you include the correct Context provider?',
		);
	}

	const plugin = ctx?.plugin as unknown as ChoreographerPluginWithState | undefined;
	const isDisplayed = Boolean(plugin?.state?.isDisplayingMessage);

	useEffect(() => {
		window.__PO_ASSET_DISPLAYED__ = window.__PO_ASSET_DISPLAYED__ || isDisplayed;
	}, [isDisplayed]);

	// Stubbed context monkey-patches the original context to prevent Choreographer components
	// from being rendered, to avoid random impact on performance and UI stability tests.
	// This is ONLY intended to use with E2E/playwright/Criterion tests loading Confluence
	// with `?stableUI=1` URL parameter.
	const stubbedContext = useMemo(
		() => ({
			...ctx,
			...choreographerContextStub,
		}),
		[ctx],
	);

	return isStableUIEnabledForTests() ? stubbedContext : ctx;
};
